import React, { useState, useContext } from "react";
import { manageMapperStore } from "../../../contexts";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import FieldSetupSlider from "./FieldSetupSlider";
import { get } from "lodash";
import MappedFieldSetup from "./MappedFieldSetup";
import { stringToFunctionConverter, FLOW_TYPES } from "../../../utils";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const MapAndTransformOutputExcelContainer = ({
  mappedData,
  setMappedData,
  dataModel,
}) => {
  const { state } = useContext(manageMapperStore);
  const { flow, profileId } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  const mappingObject = get(state, "api.data.mappingObjectMaps", []);
  const sortedData = mappingObject.sort((a, b) => {
    return a.sortOrder >= b.sortOrder ? 1 : -1;
  });

  const hasHeader = get(state, "api.data.hasHeader", "");
  const [showSlideOut, setShowSlideOut] = useState(false);
  const [fieldIndex, setFieldIndex] = useState(0);
  const [fieldArrayName, setFieldArrayName] = useState(null);

  useDeepEffect(() => {
    setMappedData([
      ...mappingObject.map((item, index) => {
        return {
          ...item,
          sortOrder: index,
        };
      }),
    ]);
  }, [mappingObject]);

  // const handleOnDragEnd = (droppedItem) => {
  //   // Ignore drop outside droppable container
  //   if (!droppedItem.destination) return;
  //   var updatedList = [...mappedData];
  //   // Remove dragged item
  //   const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
  //   // Add dropped item
  //   updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
  //   // Update State
  //   setMappedData(updatedList);
  // };

  const handleOnDragEnd = (props) => {
    if (!props.destination) return;
    let list = mappedData;

    let [final] = list.splice(props.source.index, 1);
    list.splice(props.destination.index, 0, final);
    let x = list.map((item, ind) => {
      return { ...item, sortOrder: ind + 1 };
    });

    setMappedData(x);
  };

  return (
    <div>
      <div className="boxForHeader">
        <div className="MappedDataMain">
          <div style={{ marginTop: "10px" }}>
            <span className="targetText">Target</span>

            <span className="countOfMappedData">
              {mappedData?.length} fields
            </span>
            <hr className="horizontal"></hr>
          </div>

          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="hierarchy">
              {(provided) => (
                <ul {...provided.droppableProps} ref={provided.innerRef}>
                  {mappedData.map((item, index) => {
                    return (
                      <Draggable
                        key={item.id}
                        draggableId={item.id?.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                          >
                            <MappedFieldSetup
                              index={index}
                              headerName={get(item, "headerValue", "null")}
                              hasHeader={hasHeader}
                              setShowSlideOut={setShowSlideOut}
                              setFieldIndex={setFieldIndex}
                              value={stringToFunctionConverter(
                                get(item, "value", "Null"),
                                0
                              )?.toString()}
                              item={item}
                            />
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <button
          className=" configText configButton m-4"
          onClick={() => {
            setFieldIndex();
            setShowSlideOut(true);
          }}
        >
          Configure New Field
        </button>
      </div>

      <FieldSetupSlider
        setShowSlideOut={setShowSlideOut}
        mappedData={mappedData}
        setMappedData={setMappedData}
        dataModel={dataModel}
        fieldIndex={fieldIndex}
        setFieldIndex={setFieldIndex}
        index={fieldIndex}
        showSlideOut={showSlideOut}
        hasHeader={hasHeader}
        fieldArrayName={fieldArrayName}
        setFieldArrayName={setFieldArrayName}
        profileId={profileId}
      />
    </div>
  );
};

export default MapAndTransformOutputExcelContainer;
